import { FC, ReactNode } from 'react';

type IRewardGuideProps = {
    children?: ReactNode;
};

export const RewardGuide: FC<IRewardGuideProps> = props => {
    const { children } = props;

    return (
        <div className={'g-guide'}>
            {children}
        </div>
    )
};
